/* Gesunda : reprend le prix du lot selectionne dans le bouton d'ajout au panier
   (« IN DEN WARENKORB — 64,90 € 200,00 € »), comme la reference.
   Ne fait rien si la page n'a pas de widget de lots. */
(function () {
  /* une page peut refuser le prix sur le bouton : il lui suffit de poser
     l'attribut data-gsd-atc-sans-prix quelque part (cf. page des patchs). */
  if (document.querySelector('[data-gsd-atc-sans-prix]')) return;

  var SEL_BTN = '.product-form:not(.sticky-atc) .product-form__submit';

  function txt(el) { return el ? el.textContent.trim() : ''; }

  function maj() {
    var bloc = document.querySelector('.kaching-bundles__block');
    if (!bloc) return;
    var bar = bloc.querySelector('.kaching-bundles__bar--selected') ||
              bloc.querySelector('.kaching-bundles__bar');
    if (!bar) return;

    var prix = txt(bar.querySelector('.kaching-bundles__bar-price'));
    var plein = txt(bar.querySelector('.kaching-bundles__bar-full-price'));
    if (!prix) return;

    document.querySelectorAll(SEL_BTN).forEach(function (btn) {
      var zone = btn.querySelector('.gsd-atc__prix');
      if (!zone) {
        zone = document.createElement('span');
        zone.className = 'gsd-atc__prix';
        var lab = btn.querySelector('span');
        if (lab) lab.insertAdjacentElement('afterend', zone);
        else btn.appendChild(zone);
      }
      var html = '<i class="gsd-atc__tiret" aria-hidden="true"></i><b>' + prix + '</b>';
      if (plein && plein !== prix) html += '<s>' + plein + '</s>';
      if (zone.innerHTML !== html) zone.innerHTML = html;
    });
  }

  function demarre() {
    var bloc = document.querySelector('.kaching-bundles__block');
    if (!bloc) return;
    maj();
    new MutationObserver(maj).observe(bloc, {
      subtree: true, childList: true, attributes: true, characterData: true
    });
    bloc.addEventListener('click', function () { setTimeout(maj, 400); });
  }

  /* le widget se monte apres le chargement : on laisse quelques essais */
  function attends(n) {
    if (document.querySelector('.kaching-bundles__bar')) { demarre(); return; }
    if (n > 0) setTimeout(function () { attends(n - 1); }, 600);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attends(25); });
  } else { attends(25); }
})();
